var BASE_URL = process.env.API_ROOT + "/api"

export default {
    REGISTER_BAROCARE_USER: BASE_URL + "/barocare/register/force/",
    FETCH_BAROCARE_NAME: BASE_URL + "/barocare/register/force/${client_uuid}",
    REGISTER_BAROCARE_USER_SPECIFY: BASE_URL + "/barocare/register/force/${client_uuid}/${group_id}"
}


// WEBPACK FOOTER //
// ./src/Config.js